import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Masonry from 'react-masonry-css';

import FAQPropTypes from '../models/FAQ/FAQPropTypes';
import FaqQuestion from './faq-question';
import { media, TitleSet, Container } from '../ui-components';

const propTypes = {
  className: PropTypes.string,
  faqs: PropTypes.arrayOf(FAQPropTypes)
};

const FaqSection = props => {
  const { faqs, className } = props;

  const breakpointColumns = {
    default: 2,
    [media.mediumTop]: 1
  };
  
  /**
   * @component renderFAQ
   * 
   * @param {object} faq
   * 
   * @return {JSX}
   */
  const renderFAQ = faq => {
    return (
      <div key={faq.question}>
        <FaqQuestion faq={faq} />
      </div>
    );
  };

  return faqs.length > 0 ? (
    <Container className={className} sectionContainer>
      <TitleSet title="Frequently asked questions" />
      <MasonryContainer>
        <Masonry breakpointCols={breakpointColumns} className="masonry-grid" columnClassName="masonry-grid-column">
          {faqs.map(renderFAQ)}
        </Masonry>
      </MasonryContainer>
    </Container>
  ) : null;
};

const MasonryContainer = styled.div`
  .masonry-grid {
    display: flex;
    margin-left: -24px;
    width: auto;
  }

  .masonry-grid-column {
    padding-left: 24px;
    background-clip: padding-box;
  }
`;

FaqSection.propTypes = propTypes;

export default FaqSection;
